import type { Messages } from '../catalogue.en'

export const clinicalTranslation: Partial<Messages> = {
  'record.translate': 'Перевести',
  'record.translationLanguageMenu': 'Язык перевода',
  'record.translationLanguageTabs': 'Отображаемый язык',
  'record.translationLanguageField': 'Отображаемый язык этого поля',
  'record.translationSavedMark': 'Сохранено',
  'record.translationBadge': 'У этого поля есть перевод',
  'record.translationTitle': 'Перевод клинической записи',
  'record.translationTranslating': 'Перевод…',
  'record.translationDiscard': 'Отменить изменения',
  'record.translationSourceDirty': 'Сохраните протокол перед переводом; кнопка «Сохранить» сохраняет протокол и перевод вместе.',
  'record.translationSwitchBlocked': 'Сохраните или отмените этот перевод перед сменой языка.',
  'record.translationStale': 'Исходная запись изменилась после того, как этот перевод был сохранён.',
  'record.translationEmpty': 'В этой записи нет непустого текста для перевода.',
  'record.translationLoadFailed': 'Не удалось загрузить сохранённые переводы.',
  'record.translationGenerateFailed': 'Не удалось подготовить перевод. Попробуйте ещё раз.',
  'record.translationKeyMissing': 'Добавьте свой ключ OpenAI в настройках учётной записи перед переводом.',
  'record.translationSourceChanged': 'Исходная запись изменилась. Перезагрузите её перед повторным переводом.',
  'record.translationSaveFailed': 'Не удалось сохранить перевод. Попробуйте ещё раз.',
  'record.translationSaveConflict': 'Этот перевод или его источник изменились в другом месте. Перезагрузите страницу перед сохранением.',
  'record.translationReplaceTitle': 'Заменить текст перевода',
  'record.translationReplaceBody': 'Новый перевод от ИИ заменит показанный сейчас текст перевода.',
  'record.translationReplaceConfirm': 'Заменить новым переводом',
  'record.translationReplaceCancel': 'Оставить текущий текст',
  'record.translationUnsavedIntent': 'Перевод клинической записи — правки, которые не были сохранены',
}
